import { deepmerge } from '@utils/deepmerge'

export const buildChartJsOptionsProp = (options) => {
  return deepmerge({
    maintainAspectRatio: false,
    interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false
    },
    plugins: {
      datalabels: false,
      legend: { position: 'bottom' },
    },
    scales: buildChartJsOptionsPropesOption(),
  }, options)
}

const buildChartJsOptionsPropesOption = () => {
  return {
    x: {
      display: true,
      border: {
        display: true
      },
      grid: {
        display: true,
      }
    },
    y: {
      display: true,
      border: {
        display: true
      },
      grid: {
        display: false
      },
    }
  }
}
